import { TFunction } from 'react-i18next'
import * as yup from 'yup'
import { LimitType, type EditLimitFormFields } from 'types/paymentLimits'
import { AMOUNT_VALIDATION_PATTERN } from 'utils/yupSchemas/createNameSchema'

export const editLimitSchema = (t: TFunction<'translation', undefined>) => {
  return yup.object<Record<keyof EditLimitFormFields, yup.AnySchema>>({
    limitType: yup
      .string()
      .oneOf(Object.values(LimitType))
      .required(
        t('fieldIsARequiredField', {
          field: t('paymentLimits.limitTypeLabel'),
          interpolation: { escapeValue: false },
        })
      ),
    amount: yup
      .string()
      .required(
        t('fieldIsARequiredField', {
          field: t('paymentLimits.amountLabel'),
          interpolation: { escapeValue: false },
        })
      )
      .matches(AMOUNT_VALIDATION_PATTERN, t('formFields.errors.invalidAmount')),
  })
}
